import { useNavigate, useLocation } from 'react-router-dom';
import { FileText, Plus, Tag, LogOut } from 'lucide-react';
import { BRAND } from '@/constants/brand';
import { useAuth } from '@/context/AuthContext';
import XperienceLogo from '@/components/ui/XperienceLogo';

const NAV = [
  { id: 'dashboard', path: '/', label: 'Cotizaciones', icon: FileText },
  { id: 'new-quote', path: '/cotizacion/nueva', label: 'Nueva cotización', icon: Plus, highlight: true },
  { id: 'discounts', path: '/descuentos', label: 'Códigos de descuento', icon: Tag },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="w-60 bg-black border-r border-neutral-900 flex flex-col h-screen flex-shrink-0">
      <div className="p-5 border-b border-neutral-900">
        <div className="flex flex-col items-center gap-3">
          <XperienceLogo className="w-8 h-8" />
          <div>
            {/* <div className="text-white font-bold tracking-wider text-xs">XPERIENCE</div> */}
            <div className="text-[10px] text-neutral-500 tracking-wider">COTIZADOR</div>
          </div>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1">
        {NAV.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all ${
                active
                  ? 'bg-neutral-900 text-white'
                  : item.highlight
                  ? 'text-brand-gold hover:bg-brand-gold/5'
                  : 'text-neutral-400 hover:bg-neutral-900/50 hover:text-white'
              }`}
            >
              <Icon className="w-4 h-4" /> {item.label}
            </button>
          );
        })}
      </nav>
      <div className="p-3 border-t border-neutral-900">
        <div className="flex items-center gap-3 px-2 py-2 rounded-lg bg-neutral-900/50">
        {user?.avatar ? (
          <img src={user.avatar} alt={user.nombre ?? user.name} className="w-9 h-9 rounded-lg object-cover" />
        ) : (
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center font-semibold text-xs"
            style={{ background: BRAND.gold, color: BRAND.black }}
          >
            {user?.iniciales ?? (user?.nombre ?? user?.name)?.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}

          </div>
        )}
          <div className="flex-1 min-w-0">
            <div className="text-white text-xs font-medium truncate">{user?.nombre ?? user?.name}</div>
            <div className="text-neutral-500 text-[10px] truncate">{user?.rol ?? user?.role}</div>
          </div>
          <button
            onClick={logout}
            className="p-1.5 text-neutral-500 hover:text-white hover:bg-neutral-800 rounded"
            title="Cerrar sesión"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
